var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunctionString(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon_function_string_management"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_function_string_management",
    "data-name": "icon_function string management",
    clipPath: "url(#clip-icon_function_string_management)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M128.572,797.981h-.59v-9.85A82.183,82.183,0,0,0,128.572,797.981Z",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 592,
    height: 522.22,
    rx: 48,
    transform: "translate(216 127.021)",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 592,
    height: 522.22,
    rx: 48,
    transform: "translate(216 127.021)",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M816,705.241a48,48,0,0,0,48-48V119.021a48,48,0,0,0-48-48H208a48,48,0,0,0-48,48v669.11a82.909,82.909,0,0,0,77.36,82.7,29.368,29.368,0,0,0,7.62.99H834.67a29.4,29.4,0,0,0,20.49-8.2,27.4,27.4,0,0,0,8.49-19.8c0-15.46-12.97-28-28.98-28H814.65V705.241ZM216,175.021a48,48,0,0,1,48-48H760a48,48,0,0,1,48,48v426.22a48,48,0,0,1-48,48H264a48,48,0,0,1-48-48Zm542.65,640.8H276.42a55.285,55.285,0,0,1-55.29-55.29c0-.4,0-.8.02-1.2a55.263,55.263,0,0,1,55.27-54.09H758.65Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("text", {
    id: "A",
    transform: "translate(347.069 547.399)",
    fill: "currentColor",
    fontSize: 463.852,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionString);
export default __webpack_public_path__ + "static/media/functionString.93bae062.svg";
export { ForwardRef as ReactComponent };